<template>
  <v-dialog v-model="dialog" persistent max-width="680" scrollable :fullscreen="$store.getters.mobile" content-class="receta-modal">
    <ValidationObserver ref="form" tag="div">
      <v-card v-if="config" :key="key" class="receta">
        <div class="receta__encabezado">
          <v-icon color="white" class="mr-2">mdi-prescription</v-icon>
          <span class="receta__titulo">{{ $t("prescription") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="cancel" :title="$t('Cancel')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="receta__cuerpo">
          <div class="receta__producto" v-if="currentItem && currentItem.product">
            <v-icon small color="orange darken-2" class="mr-1">mdi-pill</v-icon>
            Fórmula para <strong>{{ currentItem.product.name }}</strong>
          </div>

          <v-row class="px-2 pt-3 pb-0">
            <v-col cols="12" lg="9" class="pb-0">
              <ng-text-keyboard
                :filled="false"
                :dense="true"
                v-model="professional_card"
                :label="$t('professional_card')"
                @keyup.enter="searchDoctor"
                @clear="clearSearch"
                hide-details
              ></ng-text-keyboard>
            </v-col>
            <v-col cols="12" lg="3" class="mt-0">
              <v-btn block color="primary" :disabled="!professional_card" @click="searchDoctor" :title="$t('Search')">
                <v-icon>mdi-magnify</v-icon> {{ $t("Search") }}
              </v-btn>
            </v-col>
          </v-row>
          <v-divider />

          <v-row v-if="searched && item.id && !editando" class="pa-2 my-0 mt-3 pb-0">
            <v-col cols="12" class="pb-0 caption grey--text text--darken-1">Médico encontrado</v-col>
            <v-col cols="12">
              <div class="receta__tarjeta">
                <div class="receta__tarjeta-nombre">{{ item.first_name || item.name }} {{ item.last_name }}</div>
                <div class="receta__tarjeta-dato">
                  <v-icon small>mdi-card-account-details-outline</v-icon> RM {{ item.professional_card }}
                </div>
                <div class="receta__tarjeta-dato" v-if="item.phone"><v-icon small>mdi-phone-outline</v-icon> {{ item.phone }}</div>
                <div class="receta__tarjeta-dato" v-if="item.email"><v-icon small>mdi-email-outline</v-icon> {{ item.email }}</div>
              </div>
              <v-btn text small color="primary" class="mt-1" @click="editando = true">
                <v-icon left small>mdi-pencil-outline</v-icon>Editar datos
              </v-btn>
            </v-col>
          </v-row>

          <v-row v-if="searched && !(item.id && !editando)" class="pa-2 my-0 mt-3 pb-0">
            <v-col cols="12" class="py-0 pb-2 caption grey--text text--darken-1">
              {{ item.id ? "Editando los datos del médico" : "No existe: completa sus datos para registrarlo" }}
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <ng-text-keyboard :filled="false" :dense="true" v-model="item.first_name" :label="$t('first_name')" :rules="{ required: true }"></ng-text-keyboard>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <ng-text-keyboard :filled="false" :dense="true" v-model="item.last_name" :label="$t('last_name')" :rules="{ required: true }"></ng-text-keyboard>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <ng-text-keyboard :filled="false" :dense="true" v-model="item.professional_card" :label="$t('professional_card')" :rules="{ required: true }"></ng-text-keyboard>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <ng-phone-keyboard :filled="false" :dense="true" v-model="item.phone" :label="$t('phone')"></ng-phone-keyboard>
            </v-col>
            <v-col cols="12" class="py-0 pb-2" v-if="!masDatos">
              <v-btn text small color="primary" @click="masDatos = true">
                <v-icon left small>mdi-plus</v-icon>Más datos (correo, dirección, documento)
              </v-btn>
            </v-col>
            <template v-if="masDatos">
              <v-col cols="12" sm="6" class="py-0">
                <ng-email-keyboard :filled="false" :dense="true" v-model="item.email" :label="$t('email')"></ng-email-keyboard>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <ng-text-keyboard :filled="false" :dense="true" v-model="item.address" :label="$t('address')"></ng-text-keyboard>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <ng-select v-model="item.type_identification" label="type_identification" url="api/v1/list/type-identification"></ng-select>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <ng-text v-model="item.identification" label="identification"></ng-text>
              </v-col>
            </template>
          </v-row>

          <v-alert v-if="faltantes.length" type="warning" dense text class="mx-2 mt-3 mb-0">
            Falta completar: {{ faltantes.join(", ") }}.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="receta__pie">
          <v-btn text large @click="cancel">{{ $t("Cancel") }}</v-btn>
          <v-btn v-if="searched" large depressed color="primary" class="receta__elegir" @click="elegir">
            {{ $t("select_doctor") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>
<script>
const DEFAULT_ITEM = {
  id: "",
  name: "",
  last_name: "",
  email: "",
  professional_card: "",
  phone: "",
  address: "",
  type_identification: null,
  identification: null
};
export default {
  components: {},
  name: "CartCustomer",
  data: () => ({
    searched: false,
    editando: false,
    masDatos: false,
    faltantes: [],
    key: 0,
    item: JSON.parse(JSON.stringify(DEFAULT_ITEM)),
    config: {
      first_name: {
        name: "first_name",
        label: "Nombres",
        required: true,
        validate: ["required"],
      },
      last_name: {
        name: "last_name",
        label: "Apellidos",
        required: true,
        validate: ["required"],
      },
      identification: {
        name: "identification",
        label: "Numero Identificación",
        required: false,
        validate: [],
      },
      email: { name: "email", label: "Email", required: false, validate: [] },
      phone: {
        name: "phone",
        label: "Celular",
        required: true,
        validate: ["required"],
      },
      address: {
        name: "address",
        label: "Dirección",
        required: false,
        validate: [],
      },
    },
    order: null,
    professional_card: "",
  }),
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    currentItem: {
      type: Object,
      default: null,
    }
  },
  //props: ['customer'],
  watch: {
    dialog(newVal, oldVal) {
      //this.setDefaultClient();
      this.setDefaultClient();
    }
  },
  mounted() {
    this.setDefaultClient();
    /*if(this.customer){
      setTimeout(() => {


      this.item = JSON.parse(JSON.stringify(this.customer));
      this.searched = true;
      this.key++;
      }, 250)
    }*/
  },
  methods: {
    // Valida al pulsar: si falta algo, abre el formulario, marca los campos y dice cuáles son.
    async elegir() {
      const ok = await this.$refs.form.validate();
      if (ok) {
        this.faltantes = [];
        this.selected();
        return;
      }
      this.editando = true;
      this.$nextTick(() => {
        const errores = this.$refs.form.errors || {};
        this.faltantes = Object.keys(errores)
          .filter((k) => errores[k] && errores[k].length)
          .map((k) => (this.$te(k) ? this.$t(k) : k));
        const campo = this.$el && this.$el.querySelector ? this.$el.querySelector(".error--text") : null;
        if (campo && campo.scrollIntoView) {
          campo.scrollIntoView({ block: "center" });
        }
      });
    },
    selected() {
      this.faltantes = [];
      const obj = JSON.parse(JSON.stringify(this.item));
      this.clear();
      this.clearSearch();
      this.searched = false;
      this.$emit("selectedPrescription", obj);
      this.key++;
    },
    cancel() {
      this.clear();
      this.clearSearch();
      this.searched = false;
      this.key++;
      this.$emit("cancel");
    },
    clear() {
      this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
    },
    searchDoctor() {
      this.editando = false;
      this.masDatos = false;
      if (this.professional_card) {
        if (this.professional_card != "" ) {
          let doc = this.professional_card;
          this.$http
            .get(
              "api/v1/list/doctor-by-professional-card",
              { professional_card: this.professional_card },
              true,
              false
            )
            .then((response) => {
              if (response.success) {
                if (response.items && response.items.length > 0) {
                  this.item = response.items[0];
                } else {
                  this.item = { professional_card: doc };
                }
              }
              this.searched = true;
            })
            .catch((e) => {
              this.searched = true;
            });
        }
      } 
    },
    clearSearch() {
      this.editando = false;
      this.masDatos = false;
      this.faltantes = [];
      this.item = {};
      this.identification = "";
      this.searched = false;
    },
    setDefaultClient() {
      if (this.currentItem && this.currentItem.data_doctor) {
        this.searched = true;
        this.item = this.currentItem.data_doctor;
      } else {
        this.searched = false;
        this.item = JSON.parse(JSON.stringify(DEFAULT_ITEM));
      }
    },
  },
};
</script>
<style>
.receta__encabezado {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 8px 0 16px;
  color: #fff;
  background: var(--pos-encabezado);
}

.receta__titulo {
  font-size: 1.2rem;
  font-weight: 500;
}

.receta__producto {
  padding: 10px 16px;
  margin: 0 -16px;
  background: #fff3e0;
  color: rgba(0, 0, 0, 0.8);
}

.receta__tarjeta {
  padding: 12px 14px;
  border: 2px solid #4caf50;
  border-radius: 12px;
  background: #fff;
}

.receta__tarjeta-nombre {
  font-size: 1.1rem;
  font-weight: 800;
  margin-bottom: 4px;
}

.receta__tarjeta-dato {
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.95rem;
}

.receta__pie {
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom)) !important;
}

.receta__elegir {
  flex: 1 1 auto;
  min-height: 48px !important;
  font-weight: 700;
}
</style>
